import React, {useState, useEffect} from "react";
import { View, Text, Button, TextInput, InteractionManager, Picker } from "react-native";
import styles from "./Style";
import {notelist} from "./notelist.json";
const Tone = require("tone");

const HomeComponenet: React.FC = () => {
    const [isDarkMode, setIsDarkMode] = useState(true);
    const [minNote, setMinNote] = useState(new String("A0"));
    const [maxNote, setMaxNote] = useState(new String("C8"));
    const [playingNote, setPlayingNote] = useState(new String(minNote));
    const [intervalID,setIntervalID] = useState<any>();
    const [intervalLength, setIntervalLength] = useState(3000);
    const [toRenderButton, setToRenderButton] = useState(Array);
  
    const [pickerItemArray, setPickerItemArray] = useState(Array);
  
    var synth = new Tone.Synth().toMaster();
  
    {
      let item;
      for(let i=0; i < notelist.length; i++){
        item=(
          <Picker.Item label={notelist[i].note} value={notelist[i].note}/>
        );
        pickerItemArray.push(item);
      }
    }
  
    function playAudio(){
      let minNoteNumber=0, maxNoteNumber=0;
      let hasFoundMinNumber=false,hasFoundMaxNumber=false;
  
      for(var i = 0;i < notelist.length; i++){
        if(notelist[i].note==minNote){
          minNoteNumber=i;
          hasFoundMinNumber=true;
        }
      }
      if(!hasFoundMinNumber){
        minNoteNumber=0;
      }
      for(var i = 0;i < notelist.length; i++){
        if(notelist[i].note==maxNote){
          maxNoteNumber=i;
          hasFoundMaxNumber=true;
        }
      }
      if(!hasFoundMaxNumber){
        maxNoteNumber=0;
      }
  
      let randomIndex=Math.ceil(Math.random() * (maxNoteNumber-minNoteNumber+1))+minNoteNumber
  
      console.log(notelist[randomIndex].note+" "+randomIndex," ",notelist[randomIndex].frequency);
  
      setPlayingNote(notelist[randomIndex].note);
  
      synth.triggerAttackRelease(notelist[randomIndex].frequency, "4n");
    }
    function doTheInterval(){
      playAudio();
      setIntervalID(setInterval(playAudio, intervalLength)); 
      console.log("should be " + intervalID);
    }
    function stopTheInterval(){
      clearInterval(intervalID);
      setIntervalID(undefined);
      console.log("should be stoped " + intervalID);
    }
    console.log(intervalID);
    useEffect(()=>{
      if(!intervalID){
        let array=[(<Button onPress={doTheInterval} title="Start Timer"/>)]
        setToRenderButton(array);
      }else{
        let array=[(<Button onPress={stopTheInterval} title="Stop Timer"/>)]
        setToRenderButton(array);
      }
      console.log(toRenderButton)
    },[intervalID]);
  
    return (
      <View
        style={styles.container}
      >
        <View
          style={styles.innerContainer}>
          <View
            style={styles.leftContainer}>
            <Text>From</Text>
            <Picker selectedValue={minNote} onValueChange={(itemValue, itemIndex) => setMinNote(itemValue)}>
              {pickerItemArray}
            </Picker>
            <Text>To</Text>
            <Picker selectedValue={maxNote} onValueChange={(itemValue, itemIndex) => setMaxNote(itemValue)}>
              {pickerItemArray}
            </Picker>
            <Button onPress={playAudio} title="Play"></Button>
            <Text>{playingNote}</Text>
          </View>
          <View style={styles.leftContainer}>
            <TextInput defaultValue={"3"} onChangeText={text=>setIntervalLength(parseFloat(text)*1000)} keyboardType={'numeric'}/>
            <Text>Seconds</Text>
            {toRenderButton}
          </View>
        </View>
      </View>
    );
}

export default HomeComponenet;